import React from "react";
import { Switch } from "@headlessui/react";
import Label from "./Label";

const Toggle = ({
  vertical,
  label,
  description,
  checked,
  onChange,
  flexAlignCls='items-left justify-between gap-3',
  marginCls='mt-3',
  labelCls='whitespace-nowrap',
  ...rest
}) => {
  const switchDefaultClasses = `relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full ${rest.disabled? 'cursor-not-allowed':'cursor-pointer'} transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-am-500`;
  const spanDefaultClasses = `pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200`;

  return (
    <Switch.Group
      as="div"
      className={`flex ${flexAlignCls} py-2 ${marginCls}`}
    >
      {(label || description) && (
        <span className="flex-grow flex flex-col">
          {label && (
            <Label
              as="span"
              className="text-sm font-medium text-black-500"
              passive
            >
              <span className={rest.disabled? labelCls + " text-gray-200": labelCls}>{label}</span>
            </Label>
          )}

          {description && (
            <p as="span" className="text-sm text-gray-500">
              {description}
            </p>
          )}
        </span>
      )}

      <Switch
        className={`${switchDefaultClasses} ${
          checked ? "bg-black-500 " : "bg-gray-200"
        }`}
        checked={checked}
        onChange={onChange}
        {...rest}
      >
        <span className="sr-only">Use setting</span>
        <span
          aria-hidden="true"
          className={`${spanDefaultClasses} ${
            checked ? "translate-x-5" : "translate-x-0"
          }`}
        />
      </Switch>
    </Switch.Group>
  );
};

export default Toggle;
